import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_URL } from "../globals/utils/constants";

const REFERENCE_DATA_CACHE_SEC = 300;

function requestId() {
  return crypto.randomUUID
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

const baseQuery = fetchBaseQuery({
  baseUrl: `${API_URL}/api/v1`,
  credentials: "include",
  prepareHeaders: (headers) => {
    if (!headers.has("X-Request-ID")) {
      headers.set("X-Request-ID", requestId());
    }
    if (!headers.has("Content-Type")) {
      headers.set("Content-Type", "application/json");
    }
    return headers;
  },
});

export const rtkApi = createApi({
  reducerPath: "api",
  baseQuery,
  tagTypes: ["BondType", "State", "County", "Obligee", "Carrier"],
  keepUnusedDataFor: REFERENCE_DATA_CACHE_SEC,
  endpoints: (builder) => ({
    getBondTypes: builder.query({
      query: () => ({ url: "bondtypes/", method: "GET" }),
      providesTags: [{ type: "BondType", id: "LIST" }],
    }),
    getStates: builder.query({
      query: () => ({ url: "states/0/", method: "GET" }),
      providesTags: [{ type: "State", id: "LIST" }],
    }),
    getCounties: builder.query({
      query: (stateId) => {
        const hasState =
          stateId !== undefined && stateId !== null && stateId !== "";
        return {
          url: hasState ? `counties-by-state/${stateId}/` : "counties/",
          method: "GET",
        };
      },
      providesTags: (result, error, stateId) => {
        const hasState =
          stateId !== undefined && stateId !== null && stateId !== "";
        return [
          {
            type: "County",
            id: hasState ? `BY_STATE_${stateId}` : "ALL",
          },
        ];
      },
    }),
    getObligees: builder.query({
      query: () => ({ url: "obligee-list-create/", method: "GET" }),
      providesTags: [{ type: "Obligee", id: "LIST" }],
    }),
    getCarriers: builder.query({
      query: () => ({ url: "carriers/0/", method: "GET" }),
      providesTags: [{ type: "Carrier", id: "LIST" }],
    }),
  }),
});

export const {
  useGetBondTypesQuery,
  useLazyGetBondTypesQuery,
  useGetStatesQuery,
  useLazyGetStatesQuery,
  useGetCountiesQuery,
  useLazyGetCountiesQuery,
  useGetObligeesQuery,
  useLazyGetObligeesQuery,
  useGetCarriersQuery,
  useLazyGetCarriersQuery,
} = rtkApi;
